import React from "react";

interface RadioButtonProps {
    id?: string;
    name: string;
    icon?: string;
    label?: string;
    value: string;
    checked: boolean;
    disabled?: boolean;
    className?: string;
    tooltip?: string;
    tooltipPlace?: string;
    onChange?: (value: string) => void;
}

class RadioButton extends React.Component<RadioButtonProps> {
    render(): React.ReactNode {
        return (
            <label
                className={`radio ${this.props.className ?? ""}`}
                data-html={true}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipPlace}>
                <input
                    id={this.props.id}
                    type="radio"
                    tabIndex={0}
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.props.checked}
                    disabled={this.props.disabled === true}
                    onChange={ev => this.props.onChange?.(ev.target.value)}
                />
                <span className="checkmark" />
                {this.props.label && (
                    <span className="text">
                        {this.props.icon && <i>{this.props.icon}</i>}
                        {this.props.label}
                    </span>
                )}
            </label>
        );
    }
}

export default RadioButton;
